export default [
  {
    path: '/configuracoes-cobranca',
    name: 'configuracaocobranca',
    component: () => import(
      '@/app-modulo/comercial/Parametrizacao/ConfiguracoesCobranca/ConfiguracoesCobranca.vue'
    ),
    meta: {
      resource: 'configuracaocobranca',
      action: 'read',
      requiredAuth: true,
      pageTitle: 'Configurações de Cobrança',
      breadcrumb: [
        {
          text: 'Configurações de Cobrança',
          to: { name: 'configuracaocobranca' },
          active: true,
        },
      ],
    },
  },
]
